import * as types from "../constants/ActionTypes";
import * as action from "../lib/BLL";
import { ResolveStatusBug } from "../lib/Tools";

export const getGlobalHeight = ( value ) => {
    return (dispatch, getState) => {
        dispatch({ type: types.GLOBAL.HEIGHT, HEIGHT: value });
    };
};

export const getGlobalWidth = ( value ) => {
    return (dispatch, getState) => {
        dispatch({ type: types.GLOBAL.WIDTH, WIDTH: value});
    };
};

export const getGlobalScroll = ( value ) => {
    return (dispatch, getState) => {
        dispatch({ type: types.GLOBAL.SCROLL_TOP, SCROLL_TOP: value });
    };
};
export const getGlobalBottom = ( value ) => {
    return (dispatch, getState) => {
        dispatch({ type: types.GLOBAL.SCROLL_BOTTOM, SCROLL_BOTTOM: value });
    };
};

/* 广告位--文字 */
export const getAdvertisingText = ( params, callback ) => {
    return (dispatch, getState) => {
        action.getAdvertisingText(params, ( json ) => {
            ResolveStatusBug(json.status, `global`, `getAdvertisingText`);
            if( json && json.results && json.status == 0 ){
                if (params.locationLabel === "PC:ONLINE:BOOKING") {
                    let { resourceList } = json.results;
                    if (resourceList) {
                        if (resourceList.length > 0) {
                            dispatch({
                                type: types.GLOBAL.CENTERMODEL,
                                CENTERMODEL: resourceList[0]
                            });
                        }
                    }
                }

                if (params.locationLabel === "PC:CATEGORY:TITLE_TEXT") {
                    let { resourceList } = json.results;
                    if (resourceList.length > 0) {
                        dispatch({
                            type: types.GLOBAL.BEAUTYHREF,
                            BEAUTYHREF: resourceList[0]
                        });
                    }
                }
                callback && callback(json.results);
            }
        });
    };
};

/* 广告位--图片 */
export const getAdvertisingImage = ( params, callback ) => {
    let _params = Object.assign({}, params);
    // 确认来源是否是首页的
    if (_params.sourcePage) {
        delete _params.sourcePage;
    }
    return (dispatch, getState) => {
        action.getAdvertisingImage(_params, ( json ) => {
            ResolveStatusBug(json.status, `global`, `getAdvertisingImage`);
            if ( json && json.results && json.status == 0 ) {
                if (params.sourcePage) {
                    let { resourceList } = json.results;
                    if (resourceList) {
                        if (resourceList.length > 0) {
                            dispatch({
                                type: types.GLOBAL.TOPRIGHTMODEL,
                                TOPRIGHTMODEL: resourceList[0]
                            });
                        }
                    }
                    
                }
                callback && callback(json.results);
            }
        });
    };
};
// 触发pageshow事件
export const isPageShow = ( value ) => {
    return (dispatch, getState) => {
        dispatch({ type: types.GLOBAL.PAGESHOW, PAGESHOW: true });
    };
};


// WEBPACK FOOTER //
// ./common/actions/global.js